export default __webpack_public_path__ + "static/media/unlockStats.0206c7cf.png";